import React from 'react'
import PropTypes from 'prop-types'
import BaseComponent from "core/gd-components/base-component/base-component"

import GlistHeaderActionsCell from "../actions/header-cell"
import ListHeaderTile from "../header/cell/cell"
import AddColumn from "src/core/gd-modules/common/add-column-new/add-column"
import FirstColumn from "../item/first-column"
import LastColumn from "../item/last-column"
import GlistGroupHeaderCell from "./group-cell"
import GroupMoreButton from "./group-more-button/group-more-button"
import GroupHeaderArrow from "./arrow/group-header-arrow"
import FieldGlistGroup from "../../../../fields3/render/glist/glist-group"
import {DND_HANDLE_COLUMN_WIDTH} from "../../manager/columns-manager/columns"

export default class GroupHeaderWithColumns extends BaseComponent {

    static propTypes = {
        module      : PropTypes.object,
        group       : PropTypes.object,

        isCollapsed : PropTypes.bool,

        onClick     : PropTypes.func,
    }

    componentDidMount() {
        gd.bus.subscribe('column:resizing', this, this.onColumnResizing);
    }

    componentWillUnmount() {
        gd.bus.unsubscribe(this)
    }

    onColumnResizing = (data) => {
        this.toggleClass('is-column-resizing', data.isResizing);
    }

    onToggleColumn = (id) => {this.props.module.columns.toggleColumn(id)}
    onNewColumn = (field) => {this.props.module.addCustomField(field)}

    renderCollapsed() {
        const field = this.props.module.fields.get(this.props.module.groupBy.value)

        const classes = Classes("group-header with-columns closed", {
            'sticky': this.props.module.titleSticky,
        })

        return (
            <div className={classes} onClick={this.props.onClick}>
                <div className="stick-left">
                    <FirstColumn module={this.props.module} onClick={this.props.onClick}>
                        <GroupHeaderArrow module        = {this.props.module}
                                          isCollapsed   = {this.props.isCollapsed}/>
                    </FirstColumn>

                    <FieldGlistGroup field={field} glist={this.props.module} data={{
                        value       : this.props.group.groupByValue,
                        isCollapsed : this.props.isCollapsed,
                        counter     : this.props.group.models.length
                    }} isCollapsed={this.props.isCollapsed} />

                    {/*{field.gList.renderGroup({*/}
                    {/*    value       : this.props.group.groupByValue,*/}
                    {/*    isCollapsed : this.props.isCollapsed,*/}
                    {/*    counter     : this.props.group.models.length*/}
                    {/*}, this.props.module, this.props.isCollapsed)}*/}
                    <GroupMoreButton isCollapsed        = {this.props.isCollapsed}
                                     onToggleCollapse   = {this.props.onClick}/>
                </div>

                <div className="line"/>
                <div className="stick-right">
                    <div className="counter">{this.props.group.models.length}</div>
                    <LastColumn module={this.props.module}/>
                </div>
            </div>
        )
    }

    renderExpanded() {
        const columnsNum = this.props.module.columns.allVisible().length

        const classes = Classes("group-header with-columns open", {
            'sticky': this.props.module.titleSticky,
        })

        const shellStyles = {
            minWidth: 'calc(100% - {0}px)'.f(this.props.module.skin.paddingLeft + this.props.module.skin.paddingRight + (this.props.module.canDndItems ? DND_HANDLE_COLUMN_WIDTH : 0))
        }

        return (
            <div className={classes} style={{width: this.props.module.columns.getCombinedWidth()}}>
                <div className="glist-row glist-header">
                    <FirstColumn module={this.props.module} onClick={this.props.onClick}>
                        <GroupHeaderArrow module        = {this.props.module}
                                          isCollapsed   = {this.props.isCollapsed}/>
                    </FirstColumn>
                    {this.props.module.canDndItems && <div className="dnd-handle-column"/>}

                    <div className="shell" style={shellStyles}>
                        {_.map(this.props.module.columns.allVisible(), (column,key)=>{
                            const isTitleField      = column.fieldId === this.props.module.config.titleField
                            const canReorderTitle   = this.props.module.titleColumnReorder

                            if (isTitleField) {
                                return <GlistGroupHeaderCell key        = {'{0}_{1}'.f(column.fieldId, key)}
                                                             module     = {this.props.module}
                                                             column     = {column}
                                                             group      = {this.props.group}
                                                             onClick    = {this.props.onClick}/>
                            } else {
                                let ListHeaderComponent
                                switch (column.type) {
                                    case 'actions'  : ListHeaderComponent = GlistHeaderActionsCell; break
                                    default         : ListHeaderComponent = ListHeaderTile; break
                                }

                                return <ListHeaderComponent key         = {'{0}_{1}'.f(column.fieldId, key)}
                                                            dndManager  = {(!isTitleField || canReorderTitle) ? this.props.module.headerDndManager : null}
                                                            module      = {this.props.module}
                                                            column      = {column}
                                                            group       = {this.props.group}
                                                            canRemove   = {!isTitleField && this.props.module.canAddColumns}
                                                            canMoveLeft = {canReorderTitle ? key !== 0 : key !== 1}
                                                            isFirst     = {key === 0}
                                                            isLast      = {key === columnsNum - 1}/>
                            }
                        })}

                        {this.props.module.config.canAddColumns &&
                            <div className="add-column">
                                <AddColumn className            = "btn-add-column"
                                           btnClass             = 'ui5-control-button s-24 fs-12 i5-plus'
                                           manageColumnsConfig  = {this.props.module.config.manageColumnsConfig}
                                           fields               = {this.props.module.fields.all()}
                                           columns              = {this.props.module.columns.all()}
                                           mandatoryColumnsIds  = {[this.props.module.config.titleField]}
                                           showAdd              = {this.props.module.canAddCustomColumns}
                                           onToggleColumn       = {this.onToggleColumn}
                                           onNewColumn          = {this.onNewColumn}/>
                            </div>}
                    </div>

                    {this.props.module.groupBy && <LastColumn module={this.props.module}/>}
                </div>
            </div>
        )
    }

    render() {
        return this.props.isCollapsed ? this.renderCollapsed() : this.renderExpanded()
    }
}
